module.exports = __webpack_public_path__ + "static/favicon-a255d5a6f560a948fe3e1420b31f3348.png";